module.exports = __webpack_public_path__ + "img/notify-white.7d292d46.svg";